import { useState, useEffect, useCallback } from 'react';
import { userApi, type User } from '@src/api/client';

type AuthState = {
  user: User | null;
  loading: boolean;
  error: string | null;
};

export function useAuth() {
  const [state, setState] = useState<AuthState>({ user: null, loading: true, error: null });

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem('auth_token');
    if (!token) {
      setState({ user: null, loading: false, error: null });
      return;
    }
    try {
      const user = await userApi.get();
      setState({ user, loading: false, error: null });
    } catch {
      setState({ user: null, loading: false, error: 'Failed to load user' });
    }
  }, []);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  const login = useCallback(
    (token: string) => {
      localStorage.setItem('auth_token', token);
      loadUser();
    },
    [loadUser],
  );

  const logout = useCallback(() => {
    localStorage.removeItem('auth_token');
    setState({ user: null, loading: false, error: null });
  }, []);

  return { ...state, login, logout, refresh: loadUser };
}
